<template>
  <div class="menu">
    <div class="menu_top">
      <div class="logo">
        <img class="logo_icon" :src="logoIcon" />
        <p class="logo_text">{{ careRings }}</p>
      </div>
    </div>
    <div class="menu_list" :style="{height: menuListHeight}">
      <ul class="menu_list_navigations">
        <li class="menu_list_nav" @click="setActive">
          <router-link to="/dashboard" class="router">
            <div class="vertical_align_div">
              <img class="nav_icon" :src="dashboardIcon" />
              {{ dashboard }}
            </div>
          </router-link>
        </li>
        <li class="menu_list_nav" @click="setActive" v-if="!browsingAccountFlg">
          <router-link to="/devices" class="router">
            <div class="vertical_align_div">
              <img class="nav_icon" :src="deviceIcon" />
              {{ devices }}
            </div>
          </router-link>
        </li>
        <li class="menu_list_nav" @click="setActive" v-if="!browsingAccountFlg">
          <router-link to="/places" class="router">
            <div class="vertical_align_div">
              <img class="nav_icon" :src="placeIcon" />
              {{ places }}
            </div>
          </router-link>
        </li>
        <li class="menu_list_nav" @click="setActive" v-if="!browsingAccountFlg">
          <router-link to="/belongs" class="router">
            <div class="vertical_align_div">
              <img class="nav_icon" :src="belongIcon" />
              {{ belongs }}
            </div>
          </router-link>
        </li>
        <li class="menu_list_nav" @click="setActive" v-if="!browsingAccountFlg">
          <router-link to="/careworkers" class="router">
            <div class="vertical_align_div">
              <img class="nav_icon" :src="careworkerIcon" />
              {{ careworkers }}
            </div>
          </router-link>
        </li>
        <li
          class="menu_list_nav"
          @click="setActive"
          v-if="showRatesFlag && !browsingAccountFlg"
        >
          <router-link to="/assessmentInfos" class="router">
            <div class="vertical_align_div">
              <img class="nav_icon" :src="assessmentInfoIcon" />
              {{ assessmentInfos }}
            </div>
          </router-link>
        </li>
        <li class="menu_list_nav" @click="setActive" v-if="browsingAccountFlg">
          <router-link to="/loginUsers" class="router">
            <div class="vertical_align_div">
              <img class="nav_icon" :src="loginUserIcon" />
              {{ loginUsers }}
            </div>
          </router-link>
        </li>
        <li class="menu_list_nav" @click="setActive">
          <router-link to="/adminAccounts" class="router">
            <div class="vertical_align_div">
              <img class="nav_icon" :src="adminAccountIcon" />
              {{ adminAccounts }}
            </div>
          </router-link>
        </li>
        <li class="menu_list_nav" @click="setActive" v-if="!browsingAccountFlg">
          <router-link to="/auditLoggings" class="router">
            <div class="vertical_align_div">
              <img class="nav_icon" :src="auditLoggingIcon" />
              {{ auditLogging }}
            </div>
          </router-link>
        </li>
        <li class="menu_list_nav" @click="setActive" v-if="!browsingAccountFlg">
          <router-link to="/loginUsers" class="router">
            <div class="vertical_align_div">
              <img class="nav_icon" :src="loginUserIcon" />
              {{ loginUsers }}
            </div>
          </router-link>
        </li>
        <li class="menu_list_nav" @click="setActive">
          <router-link to="/notifications" class="router">
            <div class="vertical_align_div">
              <img class="nav_icon" :src="notificationsIcon" />
              {{ notifications }}
            </div>
          </router-link>
        </li>
        <li class="menu_list_nav" @click="setActive" v-if="!browsingAccountFlg">
          <router-link to="/assigns" class="router">
            <div class="vertical_align_div">
              <img class="nav_icon" :src="assignIcon" />
              {{ assigns }}
            </div>
          </router-link>
        </li>
        <li class="menu_list_nav" @click="setActive" v-if="!browsingAccountFlg">
          <router-link to="/reserve" class="router">
            <div class="vertical_align_div">
              <img class="nav_icon" :src="reserveIcon" />
              {{ reserve }}
            </div>
          </router-link>
        </li>
      </ul>
    </div>
    <menuBottom></menuBottom>
  </div>
</template>

<script>
import menuBottom from './menubottom.vue'

export default {
  data() {
    return {
      logoIcon: require('../img/logo.png'),
      careRings: 'CareRings',
      dashboard: 'トップページ',
      devices: '端末一覧',
      places: '拠点一覧',
      belongs: '所属一覧',
      careworkers: 'ケアワーカー一覧',
      assessmentInfos: '評価情報管理機能',
      adminAccounts: 'アカウント設定',
      auditLogging: '監査ログ機能',
      loginUsers: 'ログインユーザ一覧',
      notifications: 'お知らせ',
      assigns: '今日の役割',
      reserve: '更新予約',
      dashboardIcon: require('../img/dashboard.png'),
      deviceIcon: require('../img/device.png'),
      placeIcon: require('../img/place.png'),
      belongIcon: require('../img/belong.png'),
      careworkerIcon: require('../img/careworker.png'),
      assessmentInfoIcon: require('../img/assessmentInfo.png'),
      adminAccountIcon: require('../img/adminAccount.png'),
      auditLoggingIcon: require('../img/auditLogging.png'),
      loginUserIcon: require('../img/loginUser.png'),
      notificationsIcon: require('../img/notifications.png'),
      assignIcon: require('../img/todaysRole.png'),
      reserveIcon: require('../img/reserve.png'),
      windowHeight: ''
    }
  },
  computed: {
    showRatesFlag() {
      return this.$store.state.masters.logoutFlagMaster.ratingQuarityEnableFlag
    },
    browsingAccountFlg() {
      return this.$store.state.masters.browsingAccountFlg
    },
    menuListHeight() {
      const otherHeight = 108
      return this.windowHeight - otherHeight + 'px'
    }
  },
  components: {
    menuBottom
  },
  async created() {
    window.addEventListener('resize', this.handleResize)
    this.updateWindowHeight()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      // ウィンドウサイズ変更時にリアルタイムでウィンドウサイズの値を更新
      this.updateWindowHeight()
    },
    updateWindowHeight() {
      this.windowHeight = window.innerHeight
    },
    setActive(e) {
      var li = e.currentTarget.parentNode.querySelectorAll('li')
      for (var i = 0; i < li.length; i++) {
        li[i].className = 'menu_list_nav'
      }
      e.currentTarget.className = 'active'
    }
  }
}
</script>
<style scoped>
.active {
  font-size: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/menulist.vue